import { render, staticRenderFns } from "./entraid-login-page.vue?vue&type=template&id=036ad5f5&scoped=true&"
import script from "./entraid-login-page.vue?vue&type=script&lang=js&"
export * from "./entraid-login-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ad5f5",
  null
  
)

export default component.exports